module.exports = __webpack_public_path__ + "img/sy3.58aab4a7.png";